import { render, staticRenderFns } from "./new_payment_form.vue?vue&type=template&id=2a11dda0&lang=pug"
import script from "./new_payment_form.vue?vue&type=script&lang=js"
export * from "./new_payment_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports